<template>
    <v-dialog persistent v-model="dialog" width="1000px">
        <v-card>
            <v-row class="pa-0 ma-0">
                <v-col cols="2">
                </v-col>
                <v-col cols="8">
                    <v-card-title class="title justify-center">View detail of additional costs ({{ kstp }})</v-card-title>
                </v-col>
                <v-col cols="2">
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary" x-small @click="addHpbk(hspt_encrid, regels[0].hpbk_encrid)">Add Costs</v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-text class="scrollableCard">
                <v-data-table
                    class="elevation-1"
                    dense
                    :items="regels"
                    :headers="headers"
                    :items-per-page="12"
                    :footer-props="{'items-per-page-options': [10, 12, 24, 50, 100]}"
                    >
                    <template v-slot:item="hpbkRegel">
                        <tr>
                            <td>{{ hpbkRegel.item.hpbk_aank_van_dat }}</td>
                            <td>{{ hpbkRegel.item.hpbk_aank_tm_dat }}</td>
                            <td>{{ hpbkRegel.item.hpbk_purchase_zin }}</td>
                            <td>{{ hpbkRegel.item.hpbk_sales_zin }}</td>
                            <td>
                                <v-btn text icon @click="rmHpbk(hpbkRegel.item.hpbk_encrid)">
                                    <v-icon small>mdi-trash-can-outline</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>
        <addHpbk ref="addHpbk" @updateData="updateDataAdd"></addHpbk>
        <rmHpbk ref="rmHpbk" @updateData="updateDataRm"></rmHpbk>
    </v-dialog>
</template>

<script>
    import addHpbk from "@/views/huis/hspt/hpbk/addHpbk.vue";
    import rmHpbk from "@/views/huis/hspt/hpbk/rmHpbk.vue";

    export default {
        components: {
            addHpbk,
            rmHpbk,
        },
        data() {
            return {
                kstp: "",
                hspt_encrid: "",
                regels: [],
                dialog: false,
                headers: [
                    { text: "Arrival from", sortable: false },
                    { text: "Arrival until", sortable: false },
                    { text: "Purchase", sortable: false },
                    { text: "Sales", sortable: false },
                    { text: "Actions", sortable: false, align: "start" }
                ],
            }
        },
        methods: {
            openDetailView(kstp, hspt_encrid, regels) {
                this.kstp = kstp;
                this.hspt_encrid = hspt_encrid;
                this.regels = regels;
                this.dialog = true;
            },
            updateDataRm(hpbk_encrid) {
                for (let iIndex=0; iIndex<this.regels.length; iIndex++) {
                    // console.log(this.regels[iIndex]);
                    if (this.regels[iIndex].hpbk_encrid === hpbk_encrid) {
                        this.regels.splice(iIndex, 1);
                        return;
                    }
                }
            },
            updateDataAdd(regel) {
                for (let iIndex=0; iIndex<this.regels.length; iIndex++) {
                    if (this.regels[iIndex].hpbk_aank_van_dat > regel.hpbk_aank_van_dat) {
                        this.regels.splice(iIndex, 0, regel);
                        return;
                    }
                }
                this.regels.push(regel);
            },

            addHpbk(hspt_encrid, hpbk_encrid) {
                this.$refs.addHpbk.openDialog(hspt_encrid, hpbk_encrid);
            },
            rmHpbk(hpbk_encrid) {
                this.$refs.rmHpbk.open(hpbk_encrid);
            },
            closeDialog() {
                this.$emit('updateData');
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>
    .scrollableCard {
        max-height: 75vh;
        /* overflow-x: auto; */
        overflow-y: auto;
    }
</style>